import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import "../Receipt.css";

const ReceiptTable = ({ rows }) => (
  <TableContainer component={Paper} className="invoice-table-container">
    <Table>
      <TableHead>
        <TableRow className="invoice-table-header">
          <TableCell>Fee</TableCell>
          <TableCell>QTY</TableCell>
          <TableCell>Unit</TableCell>
          <TableCell>Sub-Total</TableCell>
          <TableCell>VAT</TableCell>
          <TableCell>Total</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, index) => (
          <TableRow key={index}>
            <TableCell>{row.fee}</TableCell>
            <TableCell>{row.qty}</TableCell>
            <TableCell>{row.unit}</TableCell>
            <TableCell>{row.subTotal}</TableCell>
            <TableCell>{row.vat}</TableCell>
            <TableCell>{row.total}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default ReceiptTable;
